import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface AvatarsContainerProps {
  children: React.ReactNode;
}

const AvatarsContainerComponent: React.FC<AvatarsContainerProps> = ({
  children,
}) => {
  return <div className="peptalk-chat-avatars">{children}</div>;
};

export const AvatarsContainer: React.FC<AvatarsContainerProps> = (
  props: AvatarsContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'AvatarsContainer',
    Component: AvatarsContainerComponent,
  });

  return <Component {...props} />;
};
